import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-pt-1 multi-range__container" }
const _hoisted_2 = { class: "q-d-flex q-justify-content-between q-pb-3 multi-range__item" }
const _hoisted_3 = { class: "q-small multi-range__min-container" }
const _hoisted_4 = { class: "multi-range__min-text" }
const _hoisted_5 = { class: "multi-range__min-value" }
const _hoisted_6 = { class: "q-small multi-range__max-container" }
const _hoisted_7 = { class: "multi-range__max-text q-ps-2" }
const _hoisted_8 = { class: "multi-range__max-value" }

import Slider from '@vueform/slider'
import {ref, watch, inject} from 'vue';
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {useSerpResultsStore} from "@/store/SerpPage/SerpResultsStore";
import {storeToRefs} from "pinia";
import {SmartSearchConfig} from "@/main";
import {formatPrice} from "@/core/utils";
import {SmartSearchTranslationsInterface} from "@/core/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiRangeSlider',
  props: ['filterData', 'field'],
  emits: ['closeDropdown'],
  setup(__props, { emit: __emit }) {

const filtersStore = useFiltersStore()

const props = __props
const minInputValue = ref<number | null>(props.filterData.min);
const maxInputValue = ref<number | null>(props.filterData.max);
const unit = ref(props.filterData.unit)
const serpStore = useSerpResultsStore()
const {getCurrencyCode} = storeToRefs(serpStore)
const {removeDecimals} = SmartSearchConfig.value.appConfiguration
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!


const format = (value: number) => {
  if (props.field === 'price') {
    return formatPrice(value, getCurrencyCode.value, removeDecimals)
  }
  return `${value.toFixed()} ${unit.value ?? ''}`;
};
const range = ref([minInputValue.value, maxInputValue.value]);

const emit = __emit;
const updateRangeValue = (newValues: Array<number>) => {
  const minValue = newValues[0]
  const maxValue = newValues[1]
  setTimeout(() => {
    filtersStore.updateRangeFilter(props.field, minValue, maxValue);
    emit('closeDropdown');
  }, 400)

}
watch(props.filterData, () => {
  filtersStore.updateRangeFilter(props.field, Number(minInputValue.value), Number(maxInputValue.value));
}, {immediate: false});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("small", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(SmartSearchTranslations).filters.from) + ": ", 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(format(__props.filterData.min)), 1)
      ]),
      _createElementVNode("small", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(SmartSearchTranslations).filters.to) + ": ", 1),
        _createElementVNode("span", _hoisted_8, _toDisplayString(format(__props.filterData.max)), 1)
      ])
    ]),
    _createVNode(_unref(Slider), {
      class: _normalizeClass('q-px-3'),
      modelValue: range.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((range).value = $event)),
      format: format,
      min: minInputValue.value,
      max: maxInputValue.value,
      onEnd: updateRangeValue
    }, null, 8, ["modelValue", "min", "max"])
  ]))
}
}

})